document.addEventListener('DOMContentLoaded', function() {

  /* ============================================
     画像サイズ変更（width=20 → width=300 など）
  ============================================ */
  function resizeTrustshopImages(root) {
    var scope = root || document;

    var imgs = scope.querySelectorAll(
      '.trustshop-one-page-product--wrap .trustshop-one-page-product--img img:not([data-trustshop-img-updated="1"])'
    );

    imgs.forEach(function(img) {
      var src = img.getAttribute('src');
      if (!src) return;

      var newSrc;

      // width=20 → width=300 へ置き換え
      if (src.includes('width=')) {
        newSrc = src.replace(/width=\d+/, 'width=300');
      } else if (src.includes('?')) {
        newSrc = src + '&width=300';
      } else {
        newSrc = src + '?width=300';
      }

      img.src = newSrc;

      // サイズ指定を削除してCSSに任せる
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.style.width = '100%';
      img.style.height = 'auto';

      img.setAttribute('data-trustshop-img-updated', '1');
    });
  }


  /* ============================================
     商品ブロックを ★ の上に移動
     → 何回呼んでも同じ結果になるように、毎回「必ず」移動するだけ
  ============================================ */
  function moveProductAboveRating(root) {
    var scope = root || document;

    var items = scope.querySelectorAll('.trustshop-review-item-type--list');

    items.forEach(function(item) {
      var body        = item.querySelector('.trustshop-review-item--body');
      if (!body) return;

      var productWrap = body.querySelector('.trustshop-one-page-product--wrap');
      var rating      = body.querySelector('.trustshop-review--rating');

      if (!productWrap || !rating) return;

      // いつ呼んでも「商品ブロックが★の直前」の状態にする
      body.insertBefore(productWrap, rating);
    });
  }


  /* ============================================
     初回実行
  ============================================ */
  resizeTrustshopImages(document);
  moveProductAboveRating(document);


  /* ============================================
     MutationObserver（追加ロードされたレビュー対応）
  ============================================ */
  var observer = new MutationObserver(function(mutations) {
    var needRerun = false;

    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        // Element(1) / DocumentFragment(11) だけ対象
        if (!node || (node.nodeType !== 1 && node.nodeType !== 11)) return;

        if (
          (node.matches && node.matches('.trustshop-review-item-type--list')) ||
          (node.querySelector && node.querySelector('.trustshop-review-item-type--list'))
        ) {
          needRerun = true;
        }
      });
    });

    if (needRerun) {
      // TrustShop 側の描画完了を少し待ってから全体に再適用
      setTimeout(function() {
        resizeTrustshopImages(document);
        moveProductAboveRating(document);
      }, 200);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });


  /* ============================================
     「さらにレビューを読み込む」クリック時の保険
  ============================================ */
  document.addEventListener('click', function(e) {
    var loadMoreBtn = e.target.closest('.trustshop-loadmore');
    if (!loadMoreBtn) return;

    setTimeout(function() {
      resizeTrustshopImages(document);
      moveProductAboveRating(document);
    }, 600); // 追加ロード完了後に再適用
  });

});

/* ============================================
   カルーセル：フッター（商品情報）を一番上に移動
   → TOPページでも Reviewページでも動く
============================================ */
function moveCarouselFooterToTop(root) {
  var scope = root || document;

  // 各カルーセルカードごとに処理
  var cards = scope.querySelectorAll('.trustshop-carousel-classic-main--container');

  cards.forEach(function (card) {
    var header = card.querySelector('.trustshop-carousel-card--header');
    var footer = card.querySelector('.trustshop-carousel-card--footer');
    if (!header || !footer) return;

    // footer を header の前に移動（結果：一番上に来る）
    card.insertBefore(footer, header);
  });
}

/* ===== 初回実行（TOPもReviewもどちらも実行される） ===== */
moveCarouselFooterToTop(document);


/* ============================================
   既存の MutationObserver にカルーセルの移動も追加
   （または別で Observer を作る）
============================================ */
var observerCarousel = new MutationObserver(function (mutations) {
  let needRerun = false;

  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (!node || (node.nodeType !== 1 && node.nodeType !== 11)) return;

      if (
        (node.matches && node.matches('.trustshop-carousel-classic-main--container')) ||
        (node.querySelector && node.querySelector('.trustshop-carousel-classic-main--container'))
      ) {
        needRerun = true;
      }
    });
  });

  if (needRerun) {
    setTimeout(function () {
      moveCarouselFooterToTop(document);
    }, 200);
  }
});

observerCarousel.observe(document.body, { childList: true, subtree: true });
